import { render, staticRenderFns } from "./AddQuestionForm.vue?vue&type=template&id=5ec65dcc&"
import script from "./AddQuestionForm.vue?vue&type=script&lang=js&"
export * from "./AddQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports